import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { forgotPassword } from "../../api/services/authService";
import { emailError } from "../../utils/validation";
import AuthLayout from "./AuthLayout";
import { AuthField } from "./AuthField";

function ForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setMessage("");
    if (emailError(email)) return setMessage(emailError(email));
    setBusy(true);
    try {
      const res = await forgotPassword(email.trim());
      // Demo mode: no email provider, so the reset code is handed to the next step instead.
      navigate("/reset-password", { state: { email: email.trim().toLowerCase(), demoCode: res.demoCode } });
    } catch (err) {
      setMessage(err.message || "Unable to start the reset. Please try again.");
    } finally {
      setBusy(false);
    }
  };
  return (
    <AuthLayout title="Forgot Password" subtitle="Enter your email and we will send a code to reset your password." footer={<button type="button" className="auth-link" onClick={() => navigate("/login")}>Back to Login</button>}>
      <form onSubmit={submit} noValidate>
        <AuthField label="Email address" icon="bi-envelope" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email Address" autoComplete="email" />
        {message && <div className="auth-error" role="alert">{message}</div>}
        <button className="auth-primary" disabled={busy}>{busy ? "Sending…" : "Send Reset Code"}</button>
      </form>
    </AuthLayout>
  );
}
export default ForgotPassword;
